import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { IconButton } from '../Common/IconButton'
import type { DragEvent } from 'react'
import type { ChecklistItem } from '../../types/schema'

type VisionboardShelfProps = {
  isOpen: boolean
  items: ChecklistItem[]
  onClose: () => void
}

export const VisionboardShelf = ({ isOpen, items, onClose }: VisionboardShelfProps) => {
  if (!isOpen) return null

  const handleDragStart = (event: DragEvent<HTMLDivElement>, checklistItem: ChecklistItem) => {
    const payload = JSON.stringify({
      id: checklistItem.id,
      title: checklistItem.title,
      weightage: checklistItem.weightage,
    })
    event.dataTransfer.setData('application/x-timelining-visionboard-item', payload)
    event.dataTransfer.effectAllowed = 'copyMove'
  }

  // The shelf accepts canvas → shelf drops via the pointer-event pipeline in
  // ChecklistDrawingBoard. The dropzone attribute below is what
  // `handlePointerUp` looks up via `document.elementFromPoint`.
  return (
    <aside
      className="calendarShelfDock"
      data-visionboard-drop-zone="true"
      aria-label="Visionboard checklist items"
      onPointerDown={(event) => event.stopPropagation()}
      onClick={(event) => event.stopPropagation()}
    >
      <header>
        <div>
          <strong>Visionboard</strong>
        </div>
        <IconButton
          variant="tertiary"
          size="sm"
          label="Close visionboard shelf"
          icon={<CloseRoundedIcon fontSize="inherit" />}
          onClick={onClose}
        />
      </header>
      <div className="calendarShelfStream" data-visionboard-drop-zone="true">
        {items.length === 0 ? (
          <div className="calendarShelfEvent" data-visionboard-drop-zone="true">
            <strong>No checklist items on the Visionboard yet.</strong>
          </div>
        ) : (
          items.map((checklistItem) => (
            <div
              key={checklistItem.id}
              className="calendarShelfEvent"
              draggable
              onDragStart={(event) => handleDragStart(event, checklistItem)}
            >
              <strong>{checklistItem.title}</strong>
              {typeof checklistItem.weightage === 'number' && (
                <span>Weight {checklistItem.weightage}</span>
              )}
            </div>
          ))
        )}
      </div>
    </aside>
  )
}
